export type VoiceCannedLineKind = 'stt' | 'render' | 'tts' | 'road';

export const CANNED_LINES: Record<VoiceCannedLineKind, string> = {
    stt: "I missed that. Try again when you're ready.",
    render: 'Signal got fuzzy. Try again in a moment.',
    tts: 'I lost my voice for a second. Try again.',
    road: "Road first. I'm pausing.",
};

export function cannedLineForError(error: unknown): VoiceCannedLineKind {
    const message = error instanceof Error ? error.message : String(error ?? '');
    if (
        message === 'stt_unavailable'
        || message === 'stt_timeout'
        || message === 'stt_no_speech'
        || message === 'stt_error'
    ) {
        return 'stt';
    }
    if (message === 'tts_empty' || message === 'tts_error') return 'tts';
    if (message.startsWith('audio_focus_') || message === 'interrupted') return 'road';
    return 'render';
}
